import React, { useEffect, useState } from "react";
import Rating from "./Rating";
import RatingTemp from "./RatingTemp";
import Pagination from "./Pagination";
import { Link } from "react-router-dom";
import RatingReact from "react-rating";
import { FaStar } from "react-icons/fa";
import { CiStar } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import {
  customer_review,
  get_reviews,
  messageClear,
} from "../store/reducers/homeReducer";
import toast from "react-hot-toast";

const Reviews = ({ product }) => {
  const dispatch = useDispatch();
  const parPage = 10;
  const [pageNumber, setPageNumber] = useState(1);

  const { userInfo } = useSelector((state) => state.auth);
  const { successMessage, reviews, rating_review, totalReview } = useSelector(
    (state) => state.home
  );

  const [rat, setRat] = useState("");
  const [re, setRe] = useState("");

  const review_submit = (e) => {
    e.preventDefault();
    const obj = {
      name: userInfo.name,
      review: re,
      rating: rat,
      productId: product._id,
    };
    dispatch(customer_review(obj));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(
        get_reviews({
          productId: product._id,
          pageNumber,
        })
      );
      setRat("");
      setRe("");
      dispatch(messageClear());
    }
  }, [successMessage, dispatch, product, pageNumber]);

  useEffect(() => {
    if (product._id) {
      dispatch(
        get_reviews({
          productId: product._id,
          pageNumber,
        })
      );
    }
  }, [pageNumber, product._id, dispatch]);

  return (
    <div className="mt-8 w-full max-w-4xl mx-auto px-4">
      <div className="flex flex-col lg:flex-row gap-10">
        {/* Rating Summary Section */}
        <div className="flex flex-col gap-2 justify-start items-start py-4 w-full lg:w-1/3">
          <div className="flex items-baseline">
            <span className="text-4xl lg:text-6xl font-semibold">
              {product.rating}
            </span>
            <span className="text-2xl lg:text-3xl font-semibold text-slate-600">
              /5
            </span>
          </div>
          <div className="flex text-2xl lg:text-3xl">
            <Rating ratings={product.rating} />
          </div>
          <p className="text-sm text-slate-600">({totalReview}) Reseñas</p>
        </div>

        {/* Rating Bars Section */}
        <div className="flex gap-2 flex-col py-4 w-full lg:w-2/3">
          {[5, 4, 3, 2, 1].map((rating, index) => (
            <div
              key={rating}
              className="flex justify-start items-center gap-3 lg:gap-5"
            >
              <div className="text-md flex gap-1 w-[70px] lg:w-[93px]">
                <RatingTemp rating={rating} />
              </div>
              <div className="w-full max-w-[200px] h-[14px] bg-slate-200 relative">
                <div
                  style={{
                    width: `${Math.floor(
                      (100 * (rating_review[index]?.sum || 0)) /
                        (totalReview || 1)
                    )}%`,
                  }}
                  className="h-full bg-[#Edbb0E]"
                ></div>
              </div>
              <p className="text-sm text-slate-600 min-w-[30px]">
                {rating_review[index]?.sum || 0}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Reviews Section */}
      <h2 className="text-slate-600 text-xl font-bold py-5">
        Reseñas de Otros Clientes ({totalReview})
      </h2>

      <div className="flex flex-col gap-8 pb-10 pt-4">
        {reviews.map((r, i) => (
          <div
            key={i}
            className="flex flex-col gap-1 bg-slate-50 p-4 rounded-lg"
          >
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
              <div className="flex gap-1 text-xl">
                <RatingTemp rating={r.rating} />
              </div>
              <span className="text-slate-600 text-sm">{r.date}</span>
            </div>
            <span className="text-slate-600 font-medium">{r.name}</span>
            <p className="text-slate-600 text-sm mt-2">{r.review}</p>
          </div>
        ))}

        <div className="flex justify-end mt-4">
          {totalReview > 5 && (
            <Pagination
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              totalItem={totalReview}
              parPage={parPage}
              showItem={Math.floor(totalReview / 3)}
            />
          )}
        </div>
      </div>

      {/* Review Form Section */}
      <div className="mt-8">
        {userInfo ? (
          <div className="flex flex-col gap-3 bg-slate-50 p-4 rounded-lg">
            <div className="flex gap-1">
              <RatingReact
                onChange={(e) => setRat(e)}
                initialRating={rat}
                emptySymbol={
                  <span className="text-slate-600 text-3xl lg:text-4xl">
                    <CiStar />
                  </span>
                }
                fullSymbol={
                  <span className="text-[#Edbb0E] text-3xl lg:text-4xl">
                    <FaStar />
                  </span>
                }
              />
            </div>
            <form onSubmit={review_submit} className="w-full">
              <textarea
                value={re}
                onChange={(e) => setRe(e.target.value)}
                required
                className="border outline-0 p-3 w-full rounded-md"
                placeholder="Write your review here..."
                rows="5"
              ></textarea>
              <div className="mt-2">
                <button className="py-2 px-6 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 transition-colors">
                  Submit
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div className="text-center sm:text-left">
            <Link
              to="/login"
              className="inline-block py-2 px-6 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
            >
              Login First
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Reviews;
